var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"productInfoTask"},[_c('Head'),_c('div',{staticClass:"detail"},[_c('taskConfiguration',{attrs:{"options":_vm.options,"adminList":_vm.adminList,"executeTypeList":_vm.executeTypeList,"sparkDetail":_vm.sparkDetail}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }